import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/production`;

export const getProductions = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const getProductionById = async (pid, prodId) => {
  return await axiosInstance.get(`${BASE(pid)}/${prodId}`);
};

export const createProduction = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const deleteProduction = async (pid, prodId) => {
  return await axiosInstance.delete(`${BASE(pid)}/${prodId}`);
};

export const getConsumptionPreview = async (pid, rpid, qty) => {
  return await axiosInstance.get(`${BASE(pid)}/preview/${rpid}`, { params: { qty } });
};